import { SolidStatusPill } from '@odo/shared-ui';

interface PermCountPillProps {
    /** The fixed noun this pill counts ("bundle"/"role"/"route") - hashed alone for a stable colour per noun. */
    noun: string;
    count: number;
}

// Count pill for the permission detail header. Zero renders the same colour
// as any other count - the number itself carries the "unwired" signal.
export function PermCountPill({ noun, count }: PermCountPillProps) {
    const label = `${count} ${noun}${count === 1 ? '' : 's'}`;
    return <SolidStatusPill value={noun} label={label} />;
}
